const env = require(`./${process.env.VUE_APP_ENV}.env`)
export default env
